var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import classNames from "classnames";
export default function FieldInfo(_a) {
    var text = _a.text, _b = _a.className, className = _b === void 0 ? "" : _b;
    return _jsxs("div", __assign({ className: classNames("text-sm text-gray-600 flex mt-2", className) }, { children: [_jsx("div", { children: _jsx(InformationCircleIcon, { className: "block w-5 h-5 mr-1 flex-grow" }) }), _jsx("div", __assign({ className: "" }, { children: text }))] }));
}
